export default function profileReducer(state ={
    profileDetail: false,
    profileUpdate: false,
    isRegistered : sessionStorage.getItem("registration_completed"),
    emailExistErr : false
}, action) {
    switch (action.type) {
        case 'FETCH_PROFILE':
            return {
                ...state,
                profileDetail: action.payload            
            };
        case 'FETCH_PROFILE_SUCCESS':
            return {
                ...state,
                // profileDetail: action.payload            
                profileDetail: action.payload?.data?.user?.role !== 'udc_admin' ? action.payload : {...action.payload, data : {...action.payload?.data, user : {...action.payload?.data?.user, role: 'prolific_admin'}}}             
            };   
        case 'UPDATE_PROFILE':
            return {
                ...state,
                profileUpdate: true,
                profileDetail: action.payload
            } 
        case "" :
            return {
                ...state,
                profileUpdate :  false
            }
        case 'REGISTER_COMPLETED':
            return {
                isRegistered : action.payload
            }

        case "REGISTER_SECOND":
            return {
                isRegistered : action.payload
            }

        default: return state
    }

}
